import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Grow, Link } from "@mui/material";
import InfoModal from "./Info";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#E3D026",
    },
  },
});

root.render(
  <ThemeProvider theme={theme}>
    <InfoModal />
    <App />
    <Grow
        in={true}
        style={{ transformOrigin: "0 0 0" }}
        {...(true ? { timeout: 2000 } : {})}
      >
        <footer>
          Made with TypeScript-React by <Link href="https://orhunulusahin.com">OU</Link>
        </footer>
      </Grow>
  </ThemeProvider>
);
